import * as React from "react";
import { Chip } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";

export default function DirectionsChip({ address }) {
  if (!address) return null;
  return (
    <Chip
      icon={<PlaceIcon />}
      label="Directions"
      size="small"
      component="a"
      href={`https://www.google.com/maps/dir//${encodeURIComponent(address)}`}
      target="_blank"
      rel="noopener noreferrer"
      clickable
      color="primary"
      variant="outlined"
    />
  );
}
